import { Company, CompanyRelation } from '../types/Company';
import { PaginatedResult } from '../types/PaginatedResult';
import { httpDelete, httpGet, httpGetBlob, httpPost, httpPost_New } from './api.service';

const getCompanies = async (request: any): Promise<PaginatedResult<Company>> => {
  return await httpGet<PaginatedResult<Company>>(`api/company`, request);
};

const getCompanyRelations = async (id: string): Promise<PaginatedResult<CompanyRelation>> => {
  return await httpGet<PaginatedResult<CompanyRelation>>(`api/company/${id}/relation`);
};

const addOrUpdateCompanyRelations = async (companyId: string, payload: Partial<CompanyRelation>): Promise<PaginatedResult<CompanyRelation>> => {
  return await httpPost<PaginatedResult<CompanyRelation>>(`api/company/${companyId}/relation`, payload);
};

const deleteCompanyRelation = async (companyId: string, relationId: string): Promise<void> => {
  return await httpDelete(`api/company/${companyId}/relation/${relationId}`);
};

const getCompanyById = async (id: string): Promise<PaginatedResult<Company>> => {
  return await httpGet<PaginatedResult<Company>>(`api/company/${id}`);
};

const addOrUpdateCompany = (company: Company) => {
  return httpPost('/api/company', company);
};

const getCompanyLogo = async (companyId?: string): Promise<Blob> => {
  return await httpGetBlob(`api/company/logo`, companyId ? { companyId } : undefined);
};

const uploadCompanyLogo = async (companyId: string, logoFile: File): Promise<any> => {
  const formData = new FormData();
  formData.append('logo', logoFile);

  return await httpPost_New(`api/company/${companyId}/logo`, formData, true);
};

export {
  getCompanies,
  getCompanyRelations,
  getCompanyById,
  addOrUpdateCompany,
  addOrUpdateCompanyRelations,
  deleteCompanyRelation,
  uploadCompanyLogo,
  getCompanyLogo,
};
